const steps = [
  {
    num: '01',
    title: 'Consultation',
    desc: 'Tell us about your event — the vibe, the crowd, the venue. We listen and start building a custom entertainment plan around your vision.',
    icon: 'ri-discuss-line',
  },
  {
    num: '02',
    title: 'Custom Planning',
    desc: 'We build your playlist, timeline, and flow together. Music genres, must-plays, do-not-plays, announcements — every detail locked in.',
    icon: 'ri-draft-line',
  },
  {
    num: '03',
    title: 'Day-Of Performance',
    desc: 'We arrive early, set up professionally, and deliver a high-energy performance that reads the room and keeps your guests engaged all night.',
    icon: 'ri-headphone-line',
  },
  {
    num: '04',
    title: 'Smooth Wrap-Up',
    desc: 'Clean, efficient breakdown after the final song. We leave your venue spotless and your guests with memories that last a lifetime.',
    icon: 'ri-checkbox-circle-line',
  },
];

export default function ProcessSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#080808] py-28 md:py-36 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_100%,_#D4AF3706_0%,_transparent_70%)] pointer-events-none"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-10 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">How It Works</span>
            <div className="w-10 h-px bg-[#D4AF37]"></div>
          </div>
          <h2
            className="text-4xl md:text-5xl font-black text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Booking Bugsie Is Simple
          </h2>
          <p className="text-gray-500 text-base max-w-md mx-auto">
            From first call to final song — a seamless process designed around your event.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 mb-16 relative">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-[52px] left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#D4AF37]/25 to-transparent z-0"></div>

          {steps.map((step, idx) => (
            <div key={step.num} className="relative z-10 flex flex-col items-center text-center px-6 py-8 group">
              {/* Circle */}
              <div className="relative mb-6">
                <div className="w-[104px] h-[104px] rounded-full border border-[#D4AF37]/20 flex items-center justify-center bg-[#0F0F0F] group-hover:border-[#D4AF37]/60 transition-all duration-500">
                  <div className="w-[80px] h-[80px] rounded-full border border-[#D4AF37]/10 flex items-center justify-center group-hover:border-[#D4AF37]/30 transition-all duration-500">
                    <span
                      className="text-[#D4AF37] font-black text-2xl"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {step.num}
                    </span>
                  </div>
                </div>
                <div className="absolute -bottom-1 -right-1 w-8 h-8 flex items-center justify-center rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30">
                  <i className={`${step.icon} text-[#D4AF37] text-sm`}></i>
                </div>
              </div>

              <h3
                className="text-white font-bold text-lg mb-3 group-hover:text-[#D4AF37] transition-colors duration-300"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>

              {idx < steps.length - 1 && (
                <div className="lg:hidden w-px h-8 bg-[#D4AF37]/20 mt-6"></div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="inline-flex items-center gap-3 border border-[#D4AF37]/60 hover:border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-bold px-12 py-4 rounded-full text-sm tracking-widest uppercase transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Check My Date
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
